// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"7cbf89ec","187":"f2fe4dbd","315":"801ff20c","338":"bb719fea","584":"8b77417e","606":"89f203c9","613":"87a4ae6e","781":"90386c0e"}[chunkId] + ".chunk.js";
};